import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, change } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { EditDailyDepositForm } from '../components/EditDailyDepositForm';
import { EDIT_DAILY_DEPOSIT_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage } from 'Components/';
import {
  EditDailyDepositTabEnum,
  EditDailyDepositTabOptions,
} from '../helpers/EditDailyDepositHelpers';
import {
  getInitialData,
  writeDeposit,
  clearError,
} from '../state/editdailydeposit/actions';
import { createToast, toastType } from 'Common/ToastHelper';

class EditDailyDepositContainer extends Component {
  static path = '/modifydailydeposits/:siteId/:servingDT/:isSupper/:tab?';

  state = {
    siteId: null,
    servingDT: null,
    isSupper: false,
    tab: EditDailyDepositTabEnum.Sales,
  };

  getRootUrl = () => {
    return this.props.match.url.replace(
      /\/modifydailydeposits\/.*/gi,
      '/modifydailydeposits/'
    );
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        formName: EDIT_DAILY_DEPOSIT_FORM_NAME,
        shown: true,
        isReadOnly: this.props.isReadOnly,
      },
    };
  };

  componentDidMount() {
    const { siteId, servingDT, isSupper, tab } = this.props.match.params;

    if (tab && EditDailyDepositTabOptions.some(o => o.value === tab)) {
      this.setState({ tab });
    }

    const params = {
      siteId: null,
      servingDT: null,
      isSupper: isSupper === '1',
    };

    if (siteId !== '0') {
      params.siteId = siteId;
      params.servingDT = servingDT;
    }

    this.setState(params);
    this.props.getInitialData(...Object.values(params));
  }

  componentDidUpdate(prevProps) {
    const {
      fetchError,
      clearError,
      history,
      newSiteId,
      newServingDT,
      newIsSupper,
    } = this.props;

    if (fetchError) {
      createToast(toastType.error, 'Error', fetchError.Message);
      clearError();
    }

    // When there is a new siteId and it isn't the same as our current siteId, reload the page with the info.
    if (newSiteId && newSiteId !== this.state.siteId) {
      history.replace(
        `${this.getRootUrl()}${newSiteId}/${newServingDT}/${
          newIsSupper ? '1' : '0'
        }/{this.state.tab}`
      );
    }
  }

  handleSubmit = values => {
    this.props.writeDeposit(values);
  };

  render() {
    const {
      formValues,
      change,
      sites,
      loading,
      fetchingData,
      initialValues,
    } = this.props;
    const { isSupper, siteId, tab } = this.state;

    var isNew = siteId === null;

    return (
      <Fragment>
        {(loading || fetchingData) && <LoadingPage />}
        <Filter
          title={
            isNew && !isSupper
              ? 'New Daily Deposit'
              : isNew && isSupper
              ? 'New Supper Daily Deposit'
              : 'Modify Daily Deposit'
          }
        />
        {!fetchingData && (
          <Main {...this.getMainProps()}>
            <EditDailyDepositForm
              isNew={isNew}
              sites={sites}
              onSubmit={this.handleSubmit}
              isSupper={isSupper}
              initialValues={initialValues}
              formValues={formValues}
              change={change}
              tab={tab}
              onTabChange={tab => this.setState({ tab })}
            />
          </Main>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { EditDailyDeposit } = state.ModifyDailyDepositState;
  return {
    formValues: getFormValues(EDIT_DAILY_DEPOSIT_FORM_NAME)(state),
    loading: EditDailyDeposit.loading,
    fetchingData: EditDailyDeposit.fetching,
    fetchError: EditDailyDeposit.fetchError,
    initialValues: EditDailyDeposit.initialValues,
    sites: EditDailyDeposit.sites,
    newSiteId: EditDailyDeposit.newSiteId,
    newServingDT: EditDailyDeposit.newServingDT,
    newIsSupper: EditDailyDeposit.newIsSupper,
  };
};

export const EditDailyDeposit = withRouter(
  connect(
    mapStateToProps,
    {
      getInitialData,
      writeDeposit,
      change,
      clearError,
    }
  )(EditDailyDepositContainer)
);



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/subpages/EditDailyDeposit.js